import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
    FacebookFilled,
    ViberFilled,
    YoutubeFilled,
    TelegramFilled,
    PhoneFilled,
} from "@assets";
import { useTranslation } from 'react-i18next';

const Container = styled.div`
position: absolute;
bottom: 0;

display: flex;
gap: 12px;

width: 100%;
padding-top: 10px;
padding-bottom: 16px;
background-color: #EFEFEF;

>div {
    flex: 1;
}
`;

const Socials = styled.div`
padding-left: 16px;
`;

const Contacts = styled.div`
padding-right: 16px;

svg {
    margin-bottom: -2px;
}

a {
    text-decoration: none !important;
}
`;

const BoldText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #101415;
`;

const LightText = styled(BoldText)`
font-weight: 400;
`;

const PhoneBox = styled.div`
display: flex;
gap: 4px;
margin-top: 6px;
margin-bottom: 1px;
`;

const SocialBox = styled.div`
display: flex;
gap: 12px;
margin-top: 7px;

svg {
    max-width: 30px;
    height: auto;
    max-height: 30px;
}
`;

const SocialsBox = () => {
    const { t } = useTranslation();
    const { settings: { social_links } } = useSelector(state => state.app);

    const Link = ({ url, children }) => (
        <a href={url} target="_blank" rel="noreferrer noopen">
            {children}
        </a>
    );

    return (
        <Container>
            <Socials>
                <BoldText>
                    {t("home.appDownloadSubTitle1")}
                </BoldText>
                <SocialBox>
                    <Link url={social_links?.fb_link}>
                        <FacebookFilled />
                    </Link>
                    <Link url={social_links?.viber_link}>
                        <ViberFilled />
                    </Link>
                    <Link url={social_links?.telegram_link}>
                        <TelegramFilled />
                    </Link>
                    <Link url={social_links?.youtube_link}>
                        <YoutubeFilled />
                    </Link>
                </SocialBox>
            </Socials>
            {/* {social_links?.phones?.length > 0 && */}
            <Contacts>
                <BoldText>
                    {t("message.contactTitle")}
                </BoldText>
                <a href={`tel:${social_links?.phones[0]}`}>
                    <PhoneBox>
                        <PhoneFilled />
                        <LightText>{social_links?.phones[0]}</LightText>
                    </PhoneBox>
                </a>
                <a href={`tel:${social_links?.phones[1]}`}>
                    <PhoneBox>
                        <PhoneFilled />
                        <LightText>{social_links?.phones[1]}</LightText>
                    </PhoneBox>
                </a>
            </Contacts>
            {/* } */}
        </Container>
    );
}

export default SocialsBox;